import { useFormat } from 'helpers/hooks/useFormat';

const EmptyCart: React.FC = () => {
  // const { loggedIn } = useContext(AccountContext);
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="flex flex-col items-center gap-9">
      <p className="text-center text-[28px]">
        {formatMessage({ id: 'cart.empty', defaultMessage: 'Non hai nessun articolo nel carrello.' })}
      </p>
    </div>
  );
};

export default EmptyCart;
